module.exports = __webpack_public_path__ + "static/img/41集约化畜牧.b32bec9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo/41集约化畜牧.jpg
// module id = WUdu
// module chunks = 0